import request from '@/utils/request'

// 检测报告管理API
export const reportApi = {
  // 分页查询检测报告
  getReportList(params) {
    return request({
      url: '/inspection-report/list',
      method: 'get',
      params
    })
  },

  // 根据报告ID获取报告详情
  getReportDetail(reportId) {
    return request({
      url: `/inspection-report/detail/${reportId}`,
      method: 'get'
    })
  },

  // 添加检测报告
  addReport(data) {
    return request({
      url: '/inspection-report/add',
      method: 'post',
      data
    })
  },

  // 更新检测报告
  updateReport(data) {
    return request({
      url: '/inspection-report/update',
      method: 'post',
      data
    })
  },

  // 删除检测报告
  deleteReport(reportId) {
    return request({
      url: `/inspection-report/delete/${reportId}`,
      method: 'delete'
    })
  }
}